let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("50jL1")).then(() => parcelRequire('bGslt'));